import React from 'react';
import Header from '../../../../components/header/Header';
import logo from '../../assets/ofc-serenity-eu__OcfLogo.png';

type HeaderType = typeof Header;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore exotic component
const HeaderOFC: HeaderType = (props) => <Header {...props} logoIcon={logo} />;
export default HeaderOFC;
